<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bfYjUJ/tc-custom/9781680571066.jpg?1734031081996" alt="This image is the cover for the book Monsters, Movies & Mayhem"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Monsters, Movies & Mayhem
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“A fun, nostalgia-filled anthology of twenty-three original, lighthearted horror tales riffing on the movie monsters of both modern cinema and B-movie favorites</b><b>.” —<i>Publishers Weekly</i></b></p><p> Lights! Camera! Monsters? </p><p> Sometimes you go to the movies. And sometimes, the movies—and their monsters—come to you. At any moment, without notice, monsters once relegated to the screen become a reality. Aliens and demons, dragons and ghosts, werewolves, vampires, zombies, and seemingly ordinary people who are just plain evil. </p><p> Join award-winning authors Jonathan Maberry, Fran Wilde, David Gerrold, Rick Wilber and others for twenty-three all-new tales of haunted theaters, video gods, formidable demons, alien pizza, and delirious actors. Each story takes you to the silver screen with monstrous results. </p><p> Funny or grim, unsettling or cozy . . . You’ll laugh! You’ll sigh! You’ll scream! </p><p> Grab popcorn—and good running shoes—and enjoy the show. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin J Anderson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0cbbfad1